module.exports = __webpack_public_path__ + "img/baiken.5f978430.jpg";